import { Container } from 'react-bootstrap'
import styled from 'styled-components'

const PageContainer = styled(Container)`
  padding-top: 66px;
`

export { PageContainer }
